import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import {handleScrollToHash} from "../services/services";
import PhoneSwiper from "../components/Common/PhoneSwiper";
import CustomTabs from "../components/Common/CustomTabs";
import LinkedBank from "../components/SHB/LinkedBank";
import TopUp from "../components/SHB/TopUp";
import Withdraw from "../components/SHB/Withdraw";


const dataLinkedBank = [
	{id: 0, title: 'Tại màn hình chính, chọn “Tài khoản” ở góc phải bên dưới màn hình'},
	{id: 1, title: 'Chọn “Quản lý Ví/ Thẻ”'},
	{id: 2, title: 'Chọn “Thêm liên kết ngân hàng”'},
	{id: 3, title: 'Chọn ngân hàng BIDV'},
	{id: 4, title: 'Nhập thông tin Số thẻ / Số tài khoản của BIDV và chọn “Liên kết”'},
	{id: 5, title: 'Nhập mã OTP được gửi về số điện thoại của bạn'},
	{id: 6, title: 'Liên kết ngân hàng thành công. Bạn có thể bắt đầu nạp tiền vào ví GooPay'},
];
const dataTopUp = [
	{id: 0, title: 'Tại giao diện chính, chọn “Nạp / Rút tiền”'},
	{id: 1, title: 'Chọn “Nạp tiền vào ví”'},
	{id: 2, title: 'Nhập số tiền cần nạp và nhấn “Tiếp tục”', subtitle: ['Lưu ý: Số tiền nạp tối thiểu 10.000 VNĐ']},
	{
		id: 3, title: 'Xác nhận thông tin nạp tiền.\n' +
			'Tại Nguồn nạp chọn Ngân hàng BIDV'
	},
	{id: 4, title: 'Nhập mã PIN để xác nhận giao dịch'},
	{id: 5, title: 'Chọn “Xác nhận”'},
	{id: 6, title: 'Nạp tiền thành công. Bạn có thể quay về trang chủ để kiểm tra số dư Ví.'},
];

const dataWithdraw = [
	{
		id: 0,
		title: 'Tại giao diện chính, chọn “Nạp / Rút tiền”',
	},
	{
		id: 1,
		title: 'Chọn “Rút tiền về ngân hàng”',
	},
	{id: 2, title: 'Nhập số tiền cần rút và “Tiếp tục”', subtitle: ['Lưu ý: Số tiền rút tối thiểu 50.000 VNĐ']},
	{
		id: 3, title: 'Chọn “Ngân hàng nhận tiền” là BIDV',
	},
	{id: 4, title: 'Nhập mã PIN'},
	{id: 5, title: 'Chọn “Xác nhận”'},
	{id: 6, title: 'Rút tiền thành công'},
];

const LinkGuideBIDV = () => {
	const [activeTab, setActiveTab] = useState(0);
	const [step, setStep] = useState(0);
	const location = useLocation();
	const {hash} = location || {};
	
	useEffect(() => {
		handleScrollToHash({sectionId: hash.substring(1)});
	}, [hash]);
	
	const tabs = [
		{
			label: 'Liên kết ngân hàng',
			quantity: 7,
			content: <LinkedBank isSHB data={dataLinkedBank} setStep={setStep} step={step}/>
		},
		{label: 'Nạp tiền vào Ví', quantity: 7, content: <TopUp isSHB data={dataTopUp} setStep={setStep} step={step}/>},
		{
			label: 'Rút tiền về ngân hàng',
			quantity: 7,
			content: <Withdraw isSHB data={dataWithdraw} setStep={setStep} step={step}/>
		},
	];
	
	const onClickTab = (index) => {
		setActiveTab(index);
	}
	
	return (
		<div className="mx-auto w-full animate-fadeIn text-sm space-y-5 md:space-y-10 pt-10">
			<div className='flex justify-center items-center text-center space-x-4 text-sm md:text-[17px] font-bold'>
				<div>
					Hướng dẫn Liên kết/ Nạp / Rút tiền với tài khoản Ngân hàng
				</div>
				<img src='/img/BIDV.svg' alt='bidv'/>
			</div>
			
			<div className="mx-auto w-fit">
				<CustomTabs
					data={tabs}
					onClickTab={onClickTab}
					activeTab={activeTab}
				/>
				<div
					className='flex flex-wrap md:font-normal justify-center items-center md:justify-start md: md:items-start font-bold md:space-x-14'>
					<div
						className="bg-transparent rounded-b-lg pb-4 md:pb-0 mx-auto"
						role="tabpanel"
						id={`tabpanel-${activeTab}`}
						aria-labelledby={`tab-${activeTab}`}
					>
						<PhoneSwiper
							path={'guild-step/linked-step-bidv'}
							activeTab={activeTab}
							step={step}
							setStep={setStep}
							setActiveTab={setActiveTab}
							quantity={tabs[activeTab]?.quantity}
						/>
					</div>
					{tabs[activeTab].content}
				</div>
			</div>
			<img className="z-[-1] mt-[-100px] md:mt-[-200px] w-full" src="/img/bg-city.png" alt="bg-city"/>
		</div>
	)
};

export default LinkGuideBIDV;
